import { useTranslations } from '@vocab/react';
import { Box, Button, IconPersonAdd } from 'braid-design-system';

import { FollowIcon } from 'src/components/atoms/Icons';

import translations from './.vocab';
interface FollowButtonProps {
  followStatus: boolean;
  onClick?: () => void;
  isLoading?: boolean;
}

export default ({
  followStatus,
  onClick,
  isLoading = false,
}: FollowButtonProps) => {
  const { t } = useTranslations(translations);

  return (
    <Box
      style={{
        width: '100%',
        maxWidth: '140px',
      }}
    >
      {!followStatus && (
        <Button
          icon={<IconPersonAdd />}
          tone="formAccent"
          variant="soft"
          onClick={onClick}
        >
          {t('follow')}
        </Button>
      )}
      {followStatus && (
        <Button
          icon={<FollowIcon />}
          tone="neutral"
          variant="ghost"
          onClick={onClick}
          loading={isLoading}
        >
          {t('following')}
        </Button>
      )}
    </Box>
  );
};
